import { Box } from 'components/Box';
import { AnimatedCheckmark } from 'components/Icon/AnimatedCheckmark';
import { Spinner } from 'components/Spinner';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

type Props = {
  submitting: boolean;
  isSubscribed: boolean;
};

export function CmsSubscribed({ submitting, isSubscribed }: Props) {
  const { isUserLoaded } = useUserEnvironment();

  if (!isUserLoaded || submitting) {
    return <Spinner size="small" label="Submitting" />;
  }

  return (
    <Box display="flex" alignItems="center">
      {isSubscribed && (
        <Box display="flex" mr="8px">
          <AnimatedCheckmark size={24} initialColorName="turtleGreen" />
        </Box>
      )}
      {isSubscribed ? getText('Subscribed!') : getText('Subscribe')}
    </Box>
  );
}
